
<template>
   <div>
      <v-container>
         <v-layout row wrap>
            <v-flex xs12>
               <v-card>
                  <v-text-field v-model="search" placeholder="rechercher..." prepend-icon="search" hide-details single-line clearable></v-text-field>
                  <v-btn block color="success" @click="openFilterDialog">Filtrage</v-btn>
                  <v-card-text>
                     <!--div>{{ filterDescription }}</div-->
                     <div>{{ filteredQuestions.length }} questions</div>
                  </v-card-text>
               </v-card>
            </v-flex>
         </v-layout>
      </v-container>

      <v-container>
         <v-flex xs12>
            <v-card>
               <v-list two-line>
                  <v-btn @click="addQuestion()"
                           fab small color="yellow"
                           top right absolute>
                     <v-icon>add</v-icon>
                  </v-btn>

                  <template v-for="(question, index) in filteredQuestions">
                     <v-list-tile ripple @click="selectQuestion(question.id)" :key="question.id"
                                 v-bind:class="{ 'red': question.id == selectedQuestionId, 'lighten-4': question.id == selectedQuestionId }">
                        <v-list-tile-action>
                           <v-icon color="pink">{{ typeIcon(question) }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                           <v-list-tile-title>{{ question.question }}</v-list-tile-title>
                           <v-list-tile-sub-title class="grey--text text--darken-4">Niveau : {{ level(question) }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                           <v-btn icon ripple @click.stop="questionToDelete = clone(question); deleteDialog = true">
                              <v-icon color="grey lighten-1">delete</v-icon>
                           </v-btn>
                           <v-btn icon ripple @click.stop="playQuestion(question)">
                              <v-icon color="grey lighten-1">play_circle_filled</v-icon>
                           </v-btn>
                        </v-list-tile-action>
                     </v-list-tile>
                     <v-divider v-if="index + 1 < filteredQuestions.length" :key="question.id + '-'"></v-divider>
                  </template>
               </v-list>

               <v-card-text v-if="filteredQuestions.length === 0" style="height: 100px;" class="Aligner">
                  <v-icon>not_interested</v-icon>
               </v-card-text>
            </v-card>
         </v-flex>

         <v-dialog v-model="deleteDialog" persistent max-width="400">
            <v-card>
               <v-card-title class="headline grey lighten-2">Confirmer</v-card-title>
               <v-card-text>Supprimer {{ questionToDelete.name }} ?</v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="brown darken-2" flat @click.native="deleteDialog = false; deleteQuestion(questionToDelete)">Supprimer</v-btn>
                  <v-btn color="brown darken-2" flat @click.native="deleteDialog = false">Annuler</v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <v-dialog v-model="filterDialog" persistent max-width="800">
            <v-card>
               <v-card-title class="headline grey lighten-2">Filtrage</v-card-title>

               <v-card-text>
                  <v-form v-model="valid">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <v-select
                                 label="Type"
                                 v-model="editedFilter.selectedTypes"
                                 multiple
                                 chips
                                 :items="types"
                                 item-text="name"
                                 item-value="uid"
                                 @change="onChanged"
                              ></v-select>
                           </v-flex>
                           <v-flex xs12>
                              <v-select
                                 label="Niveau"
                                 v-model="editedFilter.selectedLevels"
                                 multiple
                                 chips
                                 :items="levels"
                                 item-text="name"
                                 item-value="uid"
                                 @change="onChanged"
                              ></v-select>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-select
                                 label="Diabète : inclure"
                                 v-model="editedFilter.includedDiabetes"
                                 multiple
                                 chips
                                 :items="diabetes"
                                 item-text="name"
                                 item-value="uid"
                                 @change="onChanged"
                              ></v-select>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-select
                                 label="Diabète : exclure"
                                 v-model="editedFilter.excludedDiabetes"
                                 multiple
                                 chips
                                 :items="diabetes"
                                 item-text="name"
                                 item-value="uid"
                                 @change="onChanged"
                              ></v-select>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-select
                                 label="Hypercholestérolémie : inclure"
                                 v-model="editedFilter.includedCholesterols"
                                 multiple
                                 chips
                                 :items="cholesterols"
                                 item-text="short"
                                 item-value="uid"
                                 @change="onChanged"
                              ></v-select>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-select
                                 label="Hypercholestérolémie : exclure"
                                 v-model="editedFilter.excludedCholesterols"
                                 multiple
                                 chips
                                 :items="cholesterols"
                                 item-text="short"
                                 item-value="uid"
                                 @change="onChanged"
                              ></v-select>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-select
                                 label="Régime sans sel : inclure"
                                 v-model="editedFilter.includedSSsels"
                                 multiple
                                 chips
                                 :items="sssels"
                                 item-text="short"
                                 item-value="uid"
                                 @change="onChanged"
                              ></v-select>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-select
                                 label="Régime sans sel : exclure"
                                 v-model="editedFilter.excludedSSsels"
                                 multiple
                                 chips
                                 :items="sssels"
                                 item-text="short"
                                 item-value="uid"
                                 @change="onChanged"
                              ></v-select>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-form>
               </v-card-text>

               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="filterDialog = false">Annuler</v-btn>
                  <v-btn @click.native="filterDialog = false; setFilter()" :dddddisabled="!dirty || !valid">OK</v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <v-dialog v-model="playDialog" max-width="800">
            <v-card>
               <v-card-title class="display-1">
                  {{ playTitle }} &nbsp;&nbsp;&nbsp;<span class="body-2">(question à {{ playPoints }})</span>
               </v-card-title>

               <v-card-text class="subheading">
                  {{ questionToPlay.question }}
               </v-card-text>

               <v-card-text class="subheading">
                  <div v-for="image in questionToPlayImages">
                     <img
                        v-if="image.pict"
                        :src="'/static/media/' + image.pict"
                        width="150"
                     />
                  </div>
               </v-card-text>

               <div v-for="item in questionToPlayItems">
                  <v-btn block @click.native="questionAnswered(item)">{{ item.proposition }}</v-btn>
               </div>

            </v-card>
         </v-dialog>

         <v-dialog v-model="answerDialog" max-width="600">
            <v-card>
               <v-card-title class="display-1">
                  {{ answeredItem.success ? "Bonne réponse !" : "Mauvaise réponse !" }}
               </v-card-title>

               <v-card-text class="subheading">
                  {{ answeredItem.answer }}
               </v-card-text>

               <v-card-actions>
                  <v-btn block @click.native="answerDialog = false; playDialog = false">Fermer</v-btn>
               </v-card-actions>

            </v-card>
         </v-dialog>

      </v-container>
   </div>
</template>


<script>
   import _ from 'lodash'
   import debounce from 'lodash/debounce'
   import qcuConstants from '@/utilities/qcuConstants.js'

   export default {

      props: {
         questions: Array,
         selectedQuestionId: Number,
      },

      data () {
         return {
            deleteDialog: false,
            questionToDelete: {},
            playDialog: false,
            questionToPlay: {},
            answerDialog: false,
            answeredItem: {},
            filterDialog: false,
            valid: false,
            dirty: false,
            editedFilter: {
               selectedTypes: ['truefalse', 'intruder', 'findadish'],
               filterTypes: false,
               selectedLevels: ['easy', 'medium', 'expert'],
               includedDiabetes: ['nodiabetes', 'type1', 'type2'],
               excludedDiabetes: [],
               includedCholesterols: ['no', 'yes'],
               excludedCholesterols: [],
               includedSSsels: ['noss', 'ss2g', 'ss4g', 'ss6g'],
               excludedSSsels: [],
            },
            currentFilter: {
               selectedTypes: ['truefalse', 'intruder', 'findadish'],
               filterTypes: false,
               selectedLevels: ['easy', 'medium', 'expert'],
               includedDiabetes: ['nodiabetes', 'type1', 'type2'],
               excludedDiabetes: [],
               includedCholesterols: ['no', 'yes'],
               excludedCholesterols: [],
               includedSSsels: ['noss', 'ss2g', 'ss4g', 'ss6g'],
               excludedSSsels: [],
            },
            search: null,
         }
      },

      computed: {
         types () {
            return qcuConstants.typeList.map(uid => qcuConstants.types[uid])
         },
         levels () {
            return qcuConstants.levelList.map(uid => qcuConstants.levels[uid])
         },
         diabetes () {
            return qcuConstants.diabetesList.map(uid => qcuConstants.diabetes[uid])
         },
         cholesterols () {
            return qcuConstants.cholesterolList.map(uid => qcuConstants.cholesterols[uid])
         },
         sssels () {
            return qcuConstants.ssselList.map(uid => qcuConstants.sssels[uid])
         },
         filteredQuestions () {
            let filtered = this.questions
            
            // type filtering
            let selectedTypes = this.currentFilter.selectedTypes
            filtered = _.filter(filtered, function(question) {
               return selectedTypes.indexOf(question.type) !== -1
            })
            // level filtering
            let selectedLevels = this.currentFilter.selectedLevels
            filtered = _.filter(filtered, function(question) {
               return selectedLevels.indexOf(question.level) !== -1
            })
            
            // diabetes questions filtering
            let includedDiabetes = this.currentFilter.includedDiabetes
            let excludedDiabetes = this.currentFilter.excludedDiabetes
            filtered = _.filter(filtered, function(question) {
               if (question.diabete.indexOf('0') !== -1 && (includedDiabetes.indexOf('nodiabetes') === -1 || excludedDiabetes.indexOf('nodiabetes') !== -1)) return false
               if (question.diabete.indexOf('1') !== -1 && (includedDiabetes.indexOf('type1') === -1 || excludedDiabetes.indexOf('type1') !== -1)) return false
               if (question.diabete.indexOf('2') !== -1 && (includedDiabetes.indexOf('type2') === -1 || excludedDiabetes.indexOf('type2') !== -1)) return false
               return true
            })
            // cholesterol questions filtering
            let includedCholesterols = this.currentFilter.includedCholesterols
            let excludedCholesterols = this.currentFilter.excludedCholesterols
            filtered = _.filter(filtered, function(question) {
               if (question.chol.indexOf('0') !== -1 && (includedCholesterols.indexOf('no') === -1 || excludedCholesterols.indexOf('nodiabetes') !== -1)) return false
               if (question.chol.indexOf('1') !== -1 && (includedCholesterols.indexOf('yes') === -1 || excludedCholesterols.indexOf('type1') !== -1)) return false
               return true
            })
            // sssel questions filtering
            let includedSSsels = this.currentFilter.includedSSsels
            let excludedSSsels = this.currentFilter.excludedSSsels
            filtered = _.filter(filtered, function(question) {
               if (question.sssel.indexOf('0') !== -1 && (includedSSsels.indexOf('noss') === -1 || excludedSSsels.indexOf('noss') !== -1)) return false
               if (question.sssel.indexOf('2') !== -1 && (includedSSsels.indexOf('ss2g') === -1 || excludedSSsels.indexOf('ss2g') !== -1)) return false
               if (question.sssel.indexOf('4') !== -1 && (includedSSsels.indexOf('ss4g') === -1 || excludedSSsels.indexOf('ss4g') !== -1)) return false
               if (question.sssel.indexOf('6') !== -1 && (includedSSsels.indexOf('ss6g') === -1 || excludedSSsels.indexOf('ss6g') !== -1)) return false
               return true
            })
            
            if (this.search !== null) {
               let searchText = this.search.toLowerCase()
               filtered = _.filter(filtered, function(question) {
                  return question.question.toLowerCase().indexOf(searchText) !== -1
               })
            }
            return filtered
         },
         playTitle () {
            return this.questionToPlay.type ? qcuConstants.types[this.questionToPlay.type].name : ''
         },
         playPoints () {
            return this.questionToPlay.level ? qcuConstants.levels[this.questionToPlay.level].points : ''
         },
         questionToPlayImages () {
            return this.questionToPlay.id
                  ? this.$store.state.nutrikiosk.qcuQuestion2qcuImageList[this.questionToPlay.id].map(qcuImageId => this.$store.state.nutrikiosk.qcuImages[qcuImageId])
                  : []
         },
         questionToPlayItems () {
            return this.questionToPlay.id
                  ? this.$store.state.nutrikiosk.qcuQuestion2qcuItemList[this.questionToPlay.id].map(qcuItemId => this.$store.state.nutrikiosk.qcuItems[qcuItemId])
                  : []
         },
      },

      methods: {
         clone (question) {
            return _.clone(question)
         },
         selectQuestion (questionId) {
            this.$emit('questionSelected', questionId)
         },
         addQuestion () {
            this.$emit('addQuestion')
         },
         deleteQuestion (question) {
            this.$emit('deleteQuestion', question)
         },
         typeIcon (question) {
            //return 'extension'
            return qcuConstants.types[question.type].icon
         },
         level (question) {
            return qcuConstants.levels[question.level].name
         },
         openFilterDialog: function() {
            //this.editedFilter = _.clone(this.currentFilter)
            this.filterDialog = true
         },
         setFilter: function() {
            this.currentFilter = _.clone(this.editedFilter)
            this.$emit('updatedList')
         },
         async playQuestion(question) {
            await this.$store.dispatch('nutrikiosk/GET_QCU_IMAGES', question.id)
            await this.$store.dispatch('nutrikiosk/GET_QCU_ITEMS', question.id)
            this.questionToPlay = _.clone(question)
            this.playDialog = true
         },
         questionAnswered: function(item) {
            this.answeredItem = item
            this.answerDialog = true
         },
         onChanged () {
            this.dirty = true
         },

      },
   };
</script>

<style scoped>
</style


// WEBPACK FOOTER //
// QCUList.vue?72e122fb